var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _g2, _path15, _g3, _path16, _g4, _path17, _g5, _path18, _g6, _path19, _g7, _path20, _path21, _path22, _path23, _path24, _g8, _path25, _g9, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g10, _path41, _g11, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhotosUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 272 182"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#jottacloud_PhotosUpload.svg__a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M1.907 35.14 194.626 1.158l25.628 145.346-192.718 33.982z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#7A4DC1",
  fillRule: "evenodd",
  d: "m195.437 0-1.969.347L2.718 33.981.75 34.33l.347 1.968 25.28 143.376.349 1.969 1.969-.346 190.749-33.635 1.969-.347-.348-1.97L195.784 1.969zM3.067 35.952 193.815 2.317l25.281 143.376-190.748 33.634z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#A475EF",
  fillRule: "evenodd",
  d: "m213.303 141.637-180.9 31.898L8.857 40.007l180.9-31.898z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m213.303 141.637-180.9 31.898L8.857 40.007l180.9-31.898z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#B89FF8",
  fillRule: "evenodd",
  d: "m213.303 141.637-180.9 31.898-3.283-18.618-4.158-23.58 180.9-31.897z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m213.303 141.637-180.9 31.898-3.283-18.618-4.158-23.58 180.9-31.897z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M51.908 146.504 77.535 1.158l192.72 33.982-25.628 145.346z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#7A4DC1",
  fillRule: "evenodd",
  d: "m76.725 0-.347 1.97-25.281 143.375-.348 1.97 1.97.347 190.748 33.635 1.97.346.348-1.969 25.281-143.376.347-1.968-1.97-.349L78.695.347zM53.067 145.693 78.347 2.317l190.748 33.635-25.281 143.375z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#B89FF8",
  fillRule: "evenodd",
  d: "M239.759 173.535 58.858 141.637 82.403 8.109l180.901 31.898z",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M239.759 173.535 58.858 141.637 82.403 8.109l180.901 31.898z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#D7CAFF",
  fillRule: "evenodd",
  d: "M258.582 66.846a32.4 32.4 0 0 0-11.95-3.433c-17.881-1.564-33.645 11.663-35.209 29.544s11.663 33.645 29.544 35.209c2.319.203 4.602.152 6.824-.121z",
  clipRule: "evenodd"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M258.582 66.846a32.4 32.4 0 0 0-11.95-3.433c-17.881-1.564-33.645 11.663-35.209 29.544s11.663 33.645 29.544 35.209c2.319.203 4.602.152 6.824-.121z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__b",
  width: 275,
  height: 216,
  x: -3,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3 215.41h274.412V0H-3z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M38.235 166.453h195.691V18.865H38.236z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__c",
  width: 275,
  height: 216,
  x: -3,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3 215.41h274.412V0H-3z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7A4DC1",
  fillRule: "evenodd",
  d: "M234.926 17.864H37.236v149.588h197.69zM39.236 165.452h193.69V19.864H39.236z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__d",
  width: 275,
  height: 216,
  x: -3,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3 215.41h274.412V0H-3z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D7CAFF",
  fillRule: "evenodd",
  d: "M44.235 99.82h183.691V24.865H44.236z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__e",
  width: 275,
  height: 216,
  x: -3,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3 215.41h274.412V0H-3z"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M44.235 99.82h183.691V24.865H44.236z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__f",
  width: 275,
  height: 216,
  x: -3,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3 215.41h274.412V0H-3z"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B89FF8",
  fillRule: "evenodd",
  d: "M44.235 117.176h183.691V99.82H44.236z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__g",
  width: 275,
  height: 216,
  x: -3,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3 215.41h274.412V0H-3z"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M44.235 117.176h183.691V99.82H44.236z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__h",
  width: 275,
  height: 216,
  x: -3,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3 215.41h274.412V0H-3z"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__h)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#A475EF",
  fillRule: "evenodd",
  d: "M44.235 160.452h183.691v-43.277H44.236z",
  clipRule: "evenodd"
}))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M188.818 99.82c0-7.42 6.014-13.433 13.433-13.433s13.434 6.014 13.434 13.433"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M189.151 99.82c0-7.42 6.014-13.433 13.433-13.433s13.434 6.014 13.434 13.433z",
  clipRule: "evenodd"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M189.151 99.82c0-7.42 6.014-13.433 13.433-13.433s13.434 6.014 13.434 13.433z",
  clipRule: "evenodd"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M190.001 105.613h25m-19 5h13"
})), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__i",
  width: 55,
  height: 110,
  x: 44,
  y: 44,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.235 44.654v108.597h54.248V44.654z"
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__i)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M55.575 101.935c6.408 4.139 15.036 2.282 19.175-4.125l5.801-8.981c2.513-3.891 2.652-8.622.806-12.522l14.903-9.171a4.697 4.697 0 0 0 1.533-6.441 4.695 4.695 0 0 0-6.441-1.533L74.474 69.549l-.025-.016-.569.352a1.326 1.326 0 0 1-1.819-1.838l3.56-5.625.025.023 6.714-10.61a4.694 4.694 0 0 0-1.452-6.459 4.696 4.696 0 0 0-6.46 1.452l-10.2 16.117-14.719 24.28-51.069 47.77 19.302 18.256 46.498-49.163",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__j",
  width: 55,
  height: 110,
  x: 44,
  y: 44,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.235 44.654v108.597h54.248V44.654z"
}))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__j)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M55.575 101.935c6.408 4.139 15.036 2.282 19.175-4.125l5.801-8.981c2.513-3.891 2.652-8.622.806-12.522l14.903-9.171a4.697 4.697 0 0 0 1.533-6.441 4.695 4.695 0 0 0-6.441-1.533L74.474 69.549l-.025-.016-.569.352a1.326 1.326 0 0 1-1.819-1.838l3.56-5.625.025.023 6.714-10.61a4.694 4.694 0 0 0-1.452-6.459 4.696 4.696 0 0 0-6.46 1.452l-10.2 16.117-14.719 24.28-51.069 47.77 19.302 18.256 46.498-49.163"
}))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M70.27 88.575a4.695 4.695 0 0 0 6.441 1.533l10.57-6.504a4.695 4.695 0 0 0 1.532-6.441 4.696 4.696 0 0 0-6.44-1.534l-10.57 6.505a4.695 4.695 0 0 0-1.533 6.44",
  clipRule: "evenodd"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M70.27 88.575a4.695 4.695 0 0 0 6.441 1.533l10.57-6.504a4.695 4.695 0 0 0 1.532-6.441 4.696 4.696 0 0 0-6.44-1.534l-10.57 6.505a4.695 4.695 0 0 0-1.533 6.44Z",
  clipRule: "evenodd"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M72.492 98.65a4.68 4.68 0 0 0 6.441 1.533l7.082-4.358a4.682 4.682 0 0 0-4.908-7.974l-7.082 4.358a4.68 4.68 0 0 0-1.533 6.44",
  clipRule: "evenodd"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M72.492 98.65a4.68 4.68 0 0 0 6.441 1.533l7.082-4.358a4.682 4.682 0 0 0-4.908-7.974l-7.082 4.358a4.68 4.68 0 0 0-1.533 6.44Z",
  clipRule: "evenodd"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#E2E1F9",
  fillRule: "evenodd",
  d: "M64.86 86.003a12.6 12.6 0 0 0-1.56-8.667z",
  clipRule: "evenodd"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M64.86 86.003a12.6 12.6 0 0 0-1.56-8.667"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m60.344 97.056 14.477-3.748a5.318 5.318 0 0 0-1.072-10.457L61.946 82.4",
  clipRule: "evenodd"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m60.344 97.056 14.477-3.748a5.318 5.318 0 0 0-1.072-10.457L61.946 82.4"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M172.169 62.214s-7-19-26.608-22.01c-38.54-5.917-38.392 27.316-38.392 27.316",
  clipRule: "evenodd"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M172.001 78.214v-16s-3.524-17.836-27.608-22.01c-38.892-6.74-37.392 27.316-37.392 27.316v11.694z",
  clipRule: "evenodd"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M107.333 84.106a7.334 7.334 0 0 1 0-14.667",
  clipRule: "evenodd"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M107.333 84.106a7.334 7.334 0 0 1 0-14.667"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M172 69.439a7.334 7.334 0 0 1 0 14.667",
  clipRule: "evenodd"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M172 69.439a7.334 7.334 0 0 1 0 14.667"
})), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__k",
  width: 101,
  height: 40,
  x: 90,
  y: 121,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M90.39 160.452h100V121.41h-100z"
}))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__k)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D7CAFF",
  fillRule: "evenodd",
  d: "M190.39 214.41h-100v-43c0-27.5 22.5-50 50-50s50 22.5 50 50z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUpload.svg__l",
  width: 101,
  height: 40,
  x: 90,
  y: 121,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M90.39 160.452h100V121.41h-100z"
}))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUpload.svg__l)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M190.39 214.41h-100v-43c0-27.5 22.5-50 50-50s50 22.5 50 50z",
  clipRule: "evenodd"
}))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M172.179 76.106v22.557c0 17.196-14.071 31.267-31.269 31.267h-2.727c-17.198 0-31.269-14.071-31.269-31.268V76.107",
  clipRule: "evenodd"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M172.179 76.106v22.557c0 17.196-14.071 31.267-31.269 31.267h-2.727c-17.198 0-31.269-14.071-31.269-31.268V76.107"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m140.78 79.426 4.781 14.967h-8.695"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M106.914 64.41c1.976-20.75 22.13-30.07 41.315-23.202m14.161 6.702c5.779 3.554 9.368 9.066 9.789 16.5"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M153.254 42.572c-4.96 8.767-18.549 13.668-27.333 10.463m32.944-7.658c-2.337 9.505-10.754 16-20.097 16.361"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fill: "#A475EF",
  fillRule: "evenodd",
  d: "M151.687 104.033c0 6.705-5.435 12.14-12.14 12.14s-12.141-5.435-12.141-12.14z",
  clipRule: "evenodd"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M151.687 104.033c0 6.705-5.435 12.14-12.14 12.14s-12.141-5.435-12.141-12.14z",
  clipRule: "evenodd"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M117.306 76.105a8.542 8.542 0 0 1 14.455-1.125m32.057 1.125a8.542 8.542 0 0 0-14.455-1.125"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  fill: "#CBB6FF",
  fillRule: "evenodd",
  d: "M146.563 114.001a12.05 12.05 0 0 1-6.93 2.17c-3.92 0-7.4-1.85-9.61-4.72 1.96-1.38 4.35-2.18 6.93-2.18 3.91 0 7.39 1.85 9.61 4.73",
  clipRule: "evenodd"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M146.563 114.002a12.05 12.05 0 0 1-6.93 2.17c-3.92 0-7.4-1.85-9.61-4.72m0-.001c1.96-1.38 4.35-2.18 6.93-2.18 3.91 0 7.39 1.85 9.61 4.73"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7A4DC1",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M44.235 160.452h183.691V24.864H44.236z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "jottacloud_PhotosUpload.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h272v182H0z"
})))));
export default SvgPhotosUpload;